package org.zq.flvtomp4.queue

import org.zq.flvtomp4.converter.ConvertMode

enum class OutputLocation {
    SAME_AS_SOURCE,
    CUSTOM,
}

enum class OverwritePolicy {
    AUTO_RENAME,
    OVERWRITE,
}

data class AppSettings(
    val mode: ConvertMode = ConvertMode.SMART,
    val quality: Int = 20,
    val outputLocation: OutputLocation = OutputLocation.SAME_AS_SOURCE,
    val customOutputDir: String? = null,
    val overwritePolicy: OverwritePolicy = OverwritePolicy.AUTO_RENAME,
    val maxConcurrentRemux: Int = 3,
    val maxConcurrentTranscode: Int = 1,
    val ffmpegPath: String = "",
    val ffprobePath: String = "",
)
